import React from 'react'
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown'
import { Link, useHistory } from 'react-router-dom'
import auth from '../../utils/auth'
import { useDispatch } from 'react-redux'
import { reset } from '../../features/account/slice'
import { useProfile } from './profile-hook'
import { useInternationalization } from '../../features/i18n'

const Avatar = ({profile, small, className, ...props}) => {
  const size = small === true ? '30px' : '40px'
  const backgroundImage = `url('${profile.logo ? profile.logo : '/images/logos/khub_peacegen.svg'}')`

  return (
    <div
      style={{backgroundImage, height: size, width: size, backgroundSize: '60%', backgroundColor: '#f8f8f8'}}
      className={`bg-no-repeat bg-center rounded-full shadow ${className}`}
      {...props}
    />
  )
}

const OrganizationDropdown = ({small}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { profile } = useProfile()
  const { translate } = useInternationalization()

  const handleSignOut = () => {
    dispatch(reset())
    auth().logout()
    history.push('/login')
  }

  return (
    <React.Fragment>
      <Dropdown>
        <DropdownTrigger>
          <div className="relative">
            <Avatar profile={profile} small={small} />
            <div
              style={{width: '8px', height: '8px', backgroundColor: '#FF5448', top: '6px', right: '0'}}
              className="rounded-full absolute"
            />
          </div>
        </DropdownTrigger>
        <DropdownContent>
          <div className="flex p-5 border-b" style={{borderColor: '#eee'}}>
            <Avatar profile={profile} small={small} className="mr-2"/>
            <Link to={`/organization/${profile.organizationId}`}>
              <div>
                <p className="font-primary normal-case text-base font-bold">
                  {profile.name}
                </p>
                <p className="font-primary normal-case font-normal text-xs text-gray-999">Official Member</p>
              </div>
            </Link>
          </div>
          <div>
            <ul className="p-5 font-primary normal-case font-normal border-b" style={{borderColor: '#eee'}}>
              <li className="mb-2">
                <Link to="/dashboard">
                  {translate('NAVIGATION', 'dashboard')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/dashboard/organization/profile">
                  {translate('ORGANIZATION', 'profile')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/dashboard/programs">
                  {translate('PROGRAM', 'plural')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/dashboard/events">
                  {translate('EVENT', 'plural')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/dashboard/resources">
                  {translate('RESOURCE', 'plural')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/dashboard/blog">
                  Blog
                </Link>
              </li>
            </ul>
            <ul className="p-5 font-primary normal-case font-normal">
              {/* <li className="mb-2">
                <Link to="/dashboard/bookmarks">
                  {translate('BOOKMARK', 'plural')}
                </Link>
              </li> */}
              <li className="mb-2">
                <Link to="/dashboard/settings">
                  {translate('DASHBOARD', 'account_settings')}
                </Link>
              </li>
              <li className="mb-2">
                <p className="font-primary font-normal" onClick={handleSignOut}>
                  {translate('AUTH', 'logout')}
                </p>
              </li>
            </ul>
          </div>
        </DropdownContent>
      </Dropdown>
    </React.Fragment>
  )
}

export { OrganizationDropdown }
